import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

export const DIALOG_TYPE = 'FIRST_TIME_USE_DIALOG_V2';

export const spendingPlanFirstTimeUseV2 = createAction(
  rootUiActions.createDialog.toString(),
  ({ initialId, callback }: { initialId?: string; callback?: (catName: string) => void }) =>
    rootUiTypes.mkRootUiData({
      type: DIALOG_TYPE,
      props: ImmutableMap({
        initialId,
        callback,
      }),
    }),
);
